export const PAGINATION_ALL_ITEMS_SIZE = 999999

export const PAGINATION_ALL_ITEMS_VALUE = {
  count: 0,
  page: 1,
  pageSize: PAGINATION_ALL_ITEMS_SIZE,
}

export const PAGINATION_DEFAULT_COUNT_VALUE = 0

export const PAGINATION_DEFAULT_PAGE_SIZE = 10

export const PAGINATION_DEFAULT_VALUE = {
  count: 0,
  page: 1,
  size: PAGINATION_DEFAULT_PAGE_SIZE,
}

export const PAGINATION_PAGE_PARAM = 'page'

export const PAGINATION_PAGE_SIZE_PARAM = 'page_size'

export const PAGINATION_PAGE_SIZES = [10, 20, 50]
